// extracted by mini-css-extract-plugin
export default {"courseAdminWrapper":"CourseAdminIconsWrapper_courseAdminWrapper__Mtq00"};